import React, { memo, useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TreeSelect, Upload, Button as AntButton } from "antd";
import {
  UploadOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import RichEditor from "../../components/RichEditor/RichEditor";
import "./TreeSelectStyled.scss";
import { useFormik } from "formik";
import utils from "../../utils";
import {
  ASSIGNEE_TYPE,
  HH_mm,
  ISO_DATE_FORMAT,
  TIME_FORMAT_LIST,
} from "../../constants";
import PopupRenameFile from "../../components/PopupRenameFile/PopupRenameFile";
import * as yup from "yup";
import moment from "moment";
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from "./CompanyWorkScheduleStyled";

const { SHOW_CHILD } = TreeSelect;

const CompanyWorkScheduleCreate = (props) => {
  const {
    open,
    handleClose,
    departmentStore,
    authenticationStore,
    loadingAnimationStore,
    createMessage,
    fileStore,
    workScheduleStore,
  } = props;
  const { createWorkSchedule } = workScheduleStore;
  const { departmentList } = departmentStore;
  const { currentUser } = authenticationStore;
  const filterCurrentUserDepartmentList = toJS(departmentList).filter(
    (el) => el.value !== currentUser?.username
  );

  useEffect(() => {
    (async () => {
      try {
        loadingAnimationStore.showSpinner(true);
        await departmentStore.getDepartmentWithUsers(
          authenticationStore.currentCompanyCode()
        );
      } catch (err) {
        console.log(err);
        createMessage(err.vi || "Có lỗi xảy ra!", true, "error");
      } finally {
        loadingAnimationStore.showSpinner(false);
      }
    })();
  }, []);

  const [advanceFilterSD, setAdvanceFilterSD] = useState(null);

  const handleChangeStartDate = (value) => {
    setAdvanceFilterSD(value);
    formik.setFieldValue("start_date", value);
  };

  const [startTime, setStartTime] = useState(null);

  const handleChangeStartTime = (value) => {
    setStartTime(value);
    formik.setFieldValue("start_time", moment(value.$d).toISOString());
  };
  const [endTime, setEndTime] = useState(null);

  const handleChangeEndTime = (value) => {
    if (moment(value.$d).isAfter(moment(startTime.$d))) {
      setEndTime(value);
      formik.setFieldValue("end_time", moment(value.$d).toISOString());
    } else {
      createMessage(
        "thời gian kết thúc không thể sớm hơn thời gian bắt đầu, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
      setEndTime(null);
    }
  };

  const [START_AT, setSTART_AT] = useState("");

  useEffect(() => {
    setSTART_AT(
      `${moment(advanceFilterSD?.$d).format(ISO_DATE_FORMAT)} ${moment(
        startTime?.$d
      ).format(HH_mm)}`
    );
  }, [advanceFilterSD, startTime]);

  const [END_AT, setEND_AT] = useState("");

  useEffect(() => {
    if (endTime !== null) {
      setEND_AT(
        `${moment(advanceFilterSD?.$d).format(ISO_DATE_FORMAT)} ${moment(
          endTime?.$d
        ).format(HH_mm)}`
      );
    } else {
      setEND_AT(null);
    }
  }, [advanceFilterSD, endTime]);

  useEffect(() => {
    formik.setFieldValue("start_at", moment(START_AT).toISOString());
    formik.setFieldValue(
      "end_at",
      END_AT ? moment(END_AT).toISOString() : null
    );
  }, [START_AT, END_AT]);

  const formik = useFormik({
    initialValues: {
      attenders: undefined,
      end_time: undefined,
      host: undefined,
      location: undefined,
      preparation: undefined,
      start_date: undefined,
      start_time: undefined,
      title: "",
      start_at: null,
      end_at: null,
      file_ids: [],
      assignees: [],
      event_notice: undefined,
      recipient_notice: [],
    },
    validationSchema: yup.object().shape({
      start_date: yup.string().required("Vui lòng chọn ngày thực hiện!"),
      start_time: yup.string().required("Vui lòng chọn thời gian bắt đầu!"),
      host: yup
        .string()
        .required("Vui lòng nhập chủ trì!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập chủ trì!"),
      location: yup
        .string()
        .required("Vui lòng nhập địa điểm")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập địa điểm!"),
    }),
    onSubmit: async (values) => {
      try {
        loadingAnimationStore.showSpinner(true);
        await createWorkSchedule(values);
        loadingAnimationStore.showSpinner(false);
        createMessage("Tạo mới sự kiện thành công!", true, "success");
      } catch (err) {
        console.log(err);
      } finally {
        handleCloseForm();
      }
    },
  });

  const handleCloseForm = () => {
    handleClose();
    formik.setErrors({});
    formik.setTouched({});
    formik.setFieldValue("attenders", null);
    formik.setFieldValue("end_time", null);
    formik.setFieldValue("host", null);
    formik.setFieldValue("location", null);
    formik.setFieldValue("preparation", null);
    formik.setFieldValue("start_date", null);
    formik.setFieldValue("start_time", null);
    formik.setFieldValue("title", null);
    formik.setFieldValue("start_at", null);
    formik.setFieldValue("end_at", null);
    formik.setFieldValue("file_ids", null);
    formik.setFieldValue("assignees", null);
    formik.setFieldValue("recipient_notice", null);
    setData("");
    setAdvanceFilterSD([]);
    setStartTime(null);
    setEndTime(null);
    setFileList([]);
    workScheduleStore.getWorkSchedule(
      moment(new Date().$d).startOf("month").format("YYYY-MM-DD"),
      moment(new Date().$d).endOf("month").format("YYYY-MM-DD")
    );
  };

  const [data, setData] = useState("");

  useEffect(() => {
    formik.setFieldValue("event_notice", data);
  }, [data]);

  const [fileList, setFileList] = useState([]);

  const handleChangeFile = useCallback((info) => {
    if (info.fileList.length === 0) {
      formik.setFieldValue("file_upload", undefined);
      setFileList([]);
      return;
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex((file) => file.name === elem.name) === index
    );
    setFileList(filteredFileList);
  }, []);

  const handleRemoveFileFromUploadList = useCallback(
    (fileUID) => {
      const newFileList = fileList.filter((file) => file.uid !== fileUID);
      setFileList(newFileList);
      if (newFileList.length === 0) {
        formik.setFieldValue("attachments", []);
      }
    },
    [fileList]
  );

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map((file) => file.originFileObj);
    const batchUploadArr = [];
    uploadFileList.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file);
      batchUploadArr.push(fileStore.uploadFile(formData));
    });
    const response = await Promise.all(batchUploadArr);
    const res = response.map((response) => response.data.file_id);
    formik.setFieldValue("file_ids", res);
  }, [fileList]);

  useEffect(() => {
    updateAttachments();
  }, [updateAttachments]);

  const [fileExt, setFileExt] = useState(undefined);
  const [fileTargetRename, setFileTargetRename] = useState(null);
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false);
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ["rename"],
      value: "",
    },
  ]);

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };

  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };

  const submitRenameFile = async (value) => {
    const index = fileTargetRename?.index;
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      );
      setFileList(newFileList);
      setIsModalVisibleRenameFile(false);
      createMessage("Đổi tên file thành công", true, "success");
    }
  };

  const handleChangeRecipientNotice = (value) => {
    const arrRecipientNotice = [];
    value
      .filter((el) => !utils.isUpper(el))
      .map((code) => {
        arrRecipientNotice.push({
          assignee_code: code,
          assignee_type: ASSIGNEE_TYPE.USER,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        });
      });
    formik.setFieldValue("recipient_notice", arrRecipientNotice);
    formik.setFieldValue("assignees", arrRecipientNotice);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw",
            mx: 0,
            zIndex: 50,
          },
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: "#2C65AC",
          }}
        >
          <span className="font-bold">Tạo mới sự kiện</span>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="start_date"
                label={
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#ff4d4f",
                        fontSize: "14px",
                        fontFamily: "SimSun,sans-serif",
                        lineHeight: 1,
                      }}
                    >
                      *
                    </span>
                    <span> Ngày thực hiện</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={advanceFilterSD}
                onChange={handleChangeStartDate}
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_date && formik.touched.start_date
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <TimePicker
                name="start_time"
                label={
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#ff4d4f",
                        fontSize: "14px",
                        fontFamily: "SimSun,sans-serif",
                        lineHeight: 1,
                      }}
                    >
                      *
                    </span>
                    <span> Thời gian bắt đầu</span>
                  </>
                }
                value={startTime}
                views={["hours", "minutes"]}
                onChange={handleChangeStartTime}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_time && formik.touched.start_time
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <TimePicker
                name="end_at"
                label={
                  <>
                    <span> Thời gian kết thúc</span>
                  </>
                }
                value={endTime}
                views={["hours", "minutes"]}
                onChange={handleChangeEndTime}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: 10 }}>
            <TextField
              name="host"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Chủ trì</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={formik.errors.host && formik.touched.host ? true : false}
            />
          </div>
          <div style={{ marginTop: 0 }}>
            <TextField
              name="location"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Địa điểm</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={
                formik.errors.location && formik.touched.location ? true : false
              }
            />
          </div>
          <div style={{ marginTop: 0 }}>
            <TextField
              name="preparation"
              id="standard-basic"
              label={<span> Chuẩn bị</span>}
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={false}
            />
          </div>
          <div style={{ marginTop: "12px" }}>
            <RichEditor
              editorContent={formik.values.event_notice}
              setData={setData}
              placeholder={"Nhập nội dung sự kiện..."}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <Upload
              valuePropName={"fileList"}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}
            >
              <AntButton
                style={{
                  color: "#fff",
                  backgroundColor: "#1677ff",
                  fontSize: "15px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
                icon={<UploadOutlined />}
              >
                <>
                  <span>Chọn tài liệu đính kèm </span>
                </>
              </AntButton>
            </Upload>
          </div>
          <UploadFileListWrapper>
            {fileList.map((file, index) => (
              <UploadFileListItem key={file.uid || file.id}>
                <FileTextOutlined />
                <span>{file.name}</span>
                <AntButton
                  className={"rename"}
                  type="text"
                  onClick={() => {
                    handleOpenPopupRenameFile(file, index);
                  }}
                >
                  Đổi tên
                </AntButton>
                <DeleteOutlined
                  onClick={() =>
                    handleRemoveFileFromUploadList(file.uid, index)
                  }
                />
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
          <div style={{ marginTop: "-8px" }}>
            <TextField
              name="attenders"
              id="standard-basic"
              label={
                <>
                  <span> Thành viên tham gia</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={false}
            />
          </div>
          <div>
            <label>Thông báo:</label>
            <br />
            <TreeSelect
              dropdownStyle={{ zIndex: 100000 }}
              treeDataSimpleMode
              treeData={filterCurrentUserDepartmentList}
              style={{ width: "100%", fontFamily: "SVNGilroy, sans-serif" }}
              showArrow
              allowClear
              showSearch
              filterTreeNode
              treeNodeFilterProp={"name"}
              treeCheckable={true}
              showCheckedStrategy={SHOW_CHILD}
              placeholder={" Người nhận thông báo"}
              onChange={handleChangeRecipientNotice}
            />
          </div>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: "#e3e4e9", position: "sticky", bottom: 0 }}
        >
          <Button
            type="button"
            style={{ fontWeight: 600 }}
            onClick={() => {
              handleCloseForm();
            }}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary"
          >
            Đóng
          </Button>
          <Button
            type="submit"
            style={{ fontWeight: 600 }}
            className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
          >
            {" "}
            Tạo
          </Button>
        </DialogActions>
      </form>
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  );
};

export default memo(
  inject(
    "departmentStore",
    "authenticationStore",
    "loadingAnimationStore",
    "fileStore",
    "workScheduleStore"
  )(observer(CompanyWorkScheduleCreate))
);
